export default __webpack_public_path__ + "static/media/mimo.49420245.png";